var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 22,
    viewBox: "0 0 12 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Chevron_Right",
    d: "M0.31854 11.7328L10.1195 21.1969C10.5495 21.6112 11.2463 21.6112 11.6775 21.1969C12.1075 20.7825 12.1075 20.1095 11.6775 19.6951L2.65391 10.982L11.6764 2.26891C12.1064 1.85454 12.1064 1.18151 11.6764 0.766095C11.2463 0.351731 10.5485 0.351731 10.1184 0.766095L0.317454 10.23C-0.105999 10.6401 -0.105999 11.3237 0.31854 11.7328Z",
    fill: "#730BDB"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrLeft);
export default __webpack_public_path__ + "static/media/arr-left.4fad867e40c1c49df5669937fdac9172.svg";
export { ForwardRef as ReactComponent };